import React from 'react'
import { Flex, Text } from 'pcln-design-system'
import PropTypes from 'prop-types'

const ExpressDealAncillaries = ({ icons, description, ...props }) =>
  icons.length > 0 && (
    <Flex {...props} alignItems='center'>
      {icons.map((Icon, i) => (
        <Icon data-testid={`express-deal-details-ancillary${i}`} key={`ancillary${i}`} size='16px' mr={1} />
      ))}
      <Text data-testid='express-deal-details-carryon-copy' fontSize={0} ml={1} bold>
        {description}
      </Text>
    </Flex>
  )

ExpressDealAncillaries.defaultProps = {
  icons: [],
}

ExpressDealAncillaries.propTypes = {
  icons: PropTypes.array,
  description: PropTypes.string,
}

export { ExpressDealAncillaries }
